import React from "react";

import DupontIconButton from "components/DupontIconButton";

import "./index.scss";

const BadgeIcon = props => {
  const { iconComponent, iconClick, badgeText, tooltip, customClass } = props;

  const getBadgeCountAttribute = () => {
    let attr = {};
    if (badgeText !== null) {
      attr = { badgetext: badgeText };
    }
    return attr;
  };

  return (
    <DupontIconButton tooltip={tooltip}>
      <span onClick={iconClick} className={`badge-icon  badge ${customClass}`} {...getBadgeCountAttribute()}>
        {iconComponent}
      </span>
    </DupontIconButton>
  );
};

export default BadgeIcon;
